export default __webpack_public_path__ + "static/media/bg-header-desktop.8694f466.svg";